import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdDialogModule, MdMenuModule } from '@angular/material';
import { ClipboardModule } from 'ngx-clipboard';

import { AccountMenuComponent } from './account-menu/account-menu.component';
import { ActDatePipe } from '../pipes/act-date.pipe';
import { ActImageComponent } from './act-image/act-image.component';
import { ActMapModule } from 'app/utilities/act-map/act-map.module';
import { AddressFormComponent } from './address-form/address-form.component';
import { AddressListComponent } from './address-list/address-list.component';
import { ApprovalActionComponent } from './approval/approval-action/approval-action.component';
import { ApprovalButtonComponent } from './approval-button/approval-button.component';
import { BannerPromotionComponent } from './banner-promotion/banner-promotion.component';
import { BillingAddressComponent } from './billing-address/billing-address.component';
import { BillingFormComponent } from './billing-address/billing-form/billing-form.component';
import { CartComponent } from './cart/cart.component';
import { CommaCurrencyPipe } from 'app/pipes/comma-currency.pipe';
import { CommonModule, DecimalPipe, TitleCasePipe } from '@angular/common';
import { DaterangepickerModule } from '../directives/daterangepicker/daterangepicker.module';
import { DialogAlertComponent } from './modal/dialog-alert/dialog-alert.component';
import { DialogCancelBookingComponent } from 'app/components/dialog-cancellation-booking/dialog-cancellation-booking.component';
import { DialogCancellationComponent } from './modal/dialog-cancellation/dialog-cancellation.component';
import { DialogComponent } from './modal/dialog/dialog.component';
import { DialogConfirmActionComponent } from './modal/dialog-confirm-action/dialog-confirm-action.component';
import { DialogConfirmComponent } from './modal/dialog-confirm/dialog-confirm.component';
import { DialogErrorComponent } from './modal/dialog-error/dialog-error.component';
import { DialogFilterBookingComponent } from 'app/components/dialog-filter-booking/dialog-filter-booking.component';
import { DialogGeneralMessageComponent } from 'app/components/modal/dialog-general-message/dialog-general-message.component';
import { DialogMapComponent } from './modal/dialog-map/dialog-map.component';
import { DialogMapNearbyComponent } from './modal/dialog-map-nearby/dialog-map-nearby.component';
import { DialogNotifyBudgetComponent } from './modal/dialog-notify-budget/dialog-notify-budget.component';
import { DialogSuccessComponent } from './modal/dialog-success/dialog-success.component';
import { DialogTermsAndConditionsComponent } from './modal/dialog-terms-and-conditions/dialog-terms-and-conditions.component';
import { FooterComponent } from './footer/footer.component';
import { FooterCopyrightComponent } from './footer-copyright/footer-copyright.component';
import { GoogleMapComponent } from './google-map/google-map.component';
import { InfoWindowContentComponent } from './modal/dialog-map-nearby/info-window-content/info-window-content.component';
import { InputSuggestionComponent } from './input-suggestion/input-suggestion.component';
import { LangDropdownComponent } from './lang-dropdown/lang-dropdown.component';
import { MenuBarComponent } from './menu-bar/menu-bar.component';
import { NgModule } from '@angular/core';
import { PaginationComponent } from './pagination/pagination.component';
import { RoomtypeItemComponent } from './roomtype-item/roomtype-item.component';
import { RoundPipe } from '../pipes/round.pipe';
import { RouterModule } from '@angular/router';
import { SearchBoxComponent } from './search-box/search-box.component';
import { ShowMoreContentBoxComponent } from './show-more-content-box/show-more-content-box.component';
import { StarRatingComponent } from './star-rating/star-rating.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { TextMaskModule } from 'angular2-text-mask';
import { TranslatePipe } from '../pipes/translate.pipe';
import { TypeaheadModule } from '../directives/typeahead/typeahead.module';
import { UnMaskInputModule } from '../directives/UnMaskInput/un-mask.module';
import { UploadFileComponent } from 'app/components/upload-file/upload-file.component';
import { environment } from 'environments/environment';
import { DialogMapPoiComponent } from './modal/dialog-map-poi/dialog-map-poi.component';
import { PromotionMenuBarComponent } from './promotion/promotion-menu-bar/promotion-menu-bar.component';
import { PromotionSearchBoxComponent } from './promotion/promotion-search-box/promotion-search-box.component';
import { DialogConditionChangeComponent } from './modal/dialog-condition-change/dialog-condition-change.component';
import { DialogSpecialDayComponent } from './modal/dialog-special-day/dialog-special-day.component';
import { DialogBookingReportComponent } from './modal/dialog-booking-report/dialog-booking-report.component';
import { FormAutocompleteComponent } from './form-autocomplete/form-autocomplete.component';
import { GalleryComponent } from './gallery/gallery.component';
import { CarouselComponent } from './carousel/carousel.component';
import { DialogQuotationFormComponent } from './modal/dialog-quotation-form/dialog-quotation-form.component';
import { SlideShowComponent } from './slide-show/slide-show.component';
import { TranslateSingularPluralPipe } from 'app/pipes/translate-singular-plural.pipe';
import { HotelRemarkInformationComponent } from './hotel-remark-information/hotel-remark-information.component';
import { ImagePreloadModule } from 'app/directives/ImagePreload/image-preload.module';
import { DialogSwitchCompanyComponent } from './menu-bar/dialog-switch-company/dialog-switch-company.component';
import { ReplaceLineBreaksPipe } from 'app/pipes/replaceLineBreaks.pipe';
import { ToggleButtonComponent } from './toggle-button/toggle-button.component';
import { FilterDropdownComponent } from './filter-dropdown/filter-dropdown.component';
import { SliderRangeComponent } from './slider-range/slider-range.component';
import { DialogTaxAddressComponent } from './modal/dialog-tax-address/dialog-tax-address.component';
import { DialogBudgetSuggestionComponent } from './modal/dialog-budget-suggestion/dialog-budget-suggestion.component';
import { DialogCartSummaryComponent } from './cart/dialog-cart-summary/dialog-cart-summary.component';
import { DialogMultiPaymentComponent } from './modal/dialog-multi-payment/dialog-multi-payment.component';
import { ServiceAndPrivacyComponent } from './service-and-privacy/service-and-privacy.component';
import { PaymentSummaryComponent } from './payment-summary/payment-summary.component';
import { PaymentMethodDetailsComponent } from './payment-method-details/payment-method-details.component';
import { BookingDetailComponent } from './booking-detail/booking-detail.component';
import { DialogSeeAllPropertiesComponent } from './modal/dialog-see-all-properties/dialog-see-all-properties.component';
import { IconDropdownComponent } from './icon-dropdown/icon-dropdown.component';
import { DialogBudgetLimitDetailComponent } from './budget-limit/dialog-budget-limit/dialog-budget-limit-detail/dialog-budget-limit-detail.component';
import { DialogBudgetLimitMobileComponent } from './budget-limit/dialog-budget-limit/dialog-budget-limit-mobile/dialog-budget-limit-mobile.component';
import { BudgetLimitComponent } from './budget-limit/budget-limit.component';
import { DialogShareBudgetComponent } from './modal/dialog-share-budget/dialog-share-budget.component';
import { DialogShareBudgetDetailComponent } from './modal/dialog-share-budget/dialog-share-budget-detail/dialog-share-budget-detail.component';
import { DialogRoomNoteComponent } from './modal/dialog-room-note/dialog-room-note.component';
import { DialogRoomNoteDescriptionComponent } from './modal/dialog-room-note-description/dialog-room-note-description.component';
import { SafeHTMLPipe } from 'app/pipes/safeHTML.pipe';
import { SubscriptionComponent } from './subscription/subscription.component';
import { DialogInformationCartComponent } from './modal/dialog-information-cart/dialog-information-cart.component';
import { SplitJoinPipe } from 'app/pipes/split-join.pipe';
import { DialogListComponent } from './modal/dialog-list/dialog-list.component';
import { FleetCardSelectBoxComponent } from './fleet-card-select-box/fleet-card-select-box.component';
import { PaymentMethodComponent } from './payment-method/payment-method.component';
import { PaymentChannelSelectBoxComponent } from './payment-channel-select-box/payment-channel-select-box.component';
import { FullyearPipe } from 'app/pipes/fullyear.pipe';
import { ActTextAreaComponent } from './act-text-area/act-text-area.component';
import { DialogCompanyCommunicationTextComponent } from './modal/dialog-company-communication-text/dialog-company-communication-text.component';
import { DialogCompanyCommunicationBannerComponent } from './modal/dialog-company-communication-banner/dialog-company-communication-banner.component';
import { BannerBillboardComponent } from './banner-billboard/banner-billboard.component';
import { DialogBannerOverlayComponent } from './modal/dialog-banner-overlay/dialog-banner-overlay.component';
import { BannerLeaderboardComponent } from './banner-leaderboard/banner-leaderboard.component';
import { DialogSwitchLangCurrencyComponent } from './menu-bar/dialog-switch-lang-currency/dialog-switch-lang-currency.component';
import { ConvertExchangePipe } from 'app/pipes/convert-exchange.pipe';
import { DialogChangePasswordComponent } from './modal/dialog-change-password/dialog-change-password.component';
import { DialogPinComponent } from './modal/dialog-pin/dialog-pin.component';
import { PinComponent } from './modal/dialog-pin/pin/pin.component';
import { DialogAlertPinComponent } from './modal/dialog-pin/dialog-alert-pin/dialog-alert-pin.component';
import { VerifyOtpComponent } from './verify-otp/verify-otp.component';
import { OtpComponent } from './verify-otp/otp/otp.component';
import { DialogPhoneComponent } from './modal/dialog-phone/dialog-phone.component';
import { VerifyMethodComponent } from './verify-otp/verify-method/verify-method.component';
import { DialogMyProfileComponent } from 'app/pages/my-profile/dialog-my-profile/dialog-my-profile.component';
import { DialogMyProfileForm } from 'app/pages/my-profile/dialog-my-profile/dialog-my-profile.form';
import { DialogTaxesFeesComponent } from './cart/dialog-taxes-fees/dialog-taxes-fees.component';
import { DialogUsePromotionCodeComponent } from './cart/dialog-use-promotion-code/dialog-use-promotion-code.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MdDialogModule,
    MdMenuModule,
    TypeaheadModule,
    DaterangepickerModule,
    ImagePreloadModule,
    RouterModule,
    TextMaskModule,
    UnMaskInputModule,
    FormsModule,
    ActMapModule.forRoot({ apiKey: environment.googleMapKey }),
    ClipboardModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MenuBarComponent,
    SearchBoxComponent,
    FooterComponent,
    FooterCopyrightComponent,
    TranslatePipe,
    ConvertExchangePipe,
    RoundPipe,
    ActDatePipe,
    CommaCurrencyPipe,
    MdDialogModule,
    MdMenuModule,
    LangDropdownComponent,
    CartComponent,
    AccountMenuComponent,
    DialogAlertComponent,
    GoogleMapComponent,
    ShowMoreContentBoxComponent,
    DialogComponent,
    ActImageComponent,
    DialogMapComponent,
    PaginationComponent,
    DialogGeneralMessageComponent,
    DialogConfirmActionComponent,
    TermsAndConditionsComponent,
    ServiceAndPrivacyComponent,
    DialogSuccessComponent,
    DialogErrorComponent,
    RoomtypeItemComponent,
    AddressListComponent,
    AddressFormComponent,
    UploadFileComponent,
    BillingAddressComponent,
    BillingFormComponent,
    DialogCancellationComponent,
    DialogNotifyBudgetComponent,
    InputSuggestionComponent,
    DialogFilterBookingComponent,
    DialogCancelBookingComponent,
    ApprovalButtonComponent,
    ApprovalActionComponent,
    InfoWindowContentComponent,
    StarRatingComponent,
    BannerPromotionComponent,
    PromotionMenuBarComponent,
    PromotionSearchBoxComponent,
    DialogSpecialDayComponent,
    DialogBookingReportComponent,
    FormAutocompleteComponent,
    GalleryComponent,
    CarouselComponent,
    SlideShowComponent,
    TranslateSingularPluralPipe,
    HotelRemarkInformationComponent,
    ReplaceLineBreaksPipe,
    ToggleButtonComponent,
    FilterDropdownComponent,
    SliderRangeComponent,
    DialogCartSummaryComponent,
    DialogMultiPaymentComponent,
    PaymentSummaryComponent,
    PaymentMethodDetailsComponent,
    BookingDetailComponent,
    DialogSeeAllPropertiesComponent,
    IconDropdownComponent,
    BudgetLimitComponent,
    DialogBudgetLimitDetailComponent,
    DialogBudgetLimitMobileComponent,
    DialogShareBudgetComponent,
    DialogShareBudgetDetailComponent,
    SafeHTMLPipe,
    SubscriptionComponent,
    SplitJoinPipe,
    FleetCardSelectBoxComponent,
    PaymentMethodComponent,
    PaymentChannelSelectBoxComponent,
    FullyearPipe,
    BannerBillboardComponent,
    BannerLeaderboardComponent,
    DialogPinComponent,
    PinComponent,
    DialogAlertPinComponent
  ],
  declarations: [
    TranslatePipe,
    ConvertExchangePipe,
    ActDatePipe,
    RoundPipe,
    CommaCurrencyPipe,
    MenuBarComponent,
    SearchBoxComponent,
    FooterComponent,
    LangDropdownComponent,
    CartComponent,
    AccountMenuComponent,
    DialogAlertComponent,
    GoogleMapComponent,
    ShowMoreContentBoxComponent,
    DialogComponent,
    ActImageComponent,
    DialogMapComponent,
    PaginationComponent,
    DialogGeneralMessageComponent,
    TermsAndConditionsComponent,
    ServiceAndPrivacyComponent,
    DialogTermsAndConditionsComponent,
    DialogSuccessComponent,
    DialogErrorComponent,
    FooterCopyrightComponent,
    RoomtypeItemComponent,
    DialogConfirmComponent,
    DialogConfirmActionComponent,
    AddressListComponent,
    AddressFormComponent,
    DialogCancellationComponent,
    DialogNotifyBudgetComponent,
    UploadFileComponent,
    BillingAddressComponent,
    BillingFormComponent,
    InputSuggestionComponent,
    DialogFilterBookingComponent,
    DialogCancelBookingComponent,
    ApprovalButtonComponent,
    ApprovalActionComponent,
    DialogMapNearbyComponent,
    DialogMapPoiComponent,
    InfoWindowContentComponent,
    StarRatingComponent,
    BannerPromotionComponent,
    DialogMapPoiComponent,
    PromotionMenuBarComponent,
    PromotionSearchBoxComponent,
    DialogConditionChangeComponent,
    DialogSpecialDayComponent,
    DialogBookingReportComponent,
    FormAutocompleteComponent,
    GalleryComponent,
    CarouselComponent,
    DialogQuotationFormComponent,
    SlideShowComponent,
    TranslateSingularPluralPipe,
    HotelRemarkInformationComponent,
    DialogSwitchCompanyComponent,
    ReplaceLineBreaksPipe,
    ToggleButtonComponent,
    FilterDropdownComponent,
    SliderRangeComponent,
    DialogTaxAddressComponent,
    DialogBudgetSuggestionComponent,
    DialogCartSummaryComponent,
    DialogMultiPaymentComponent,
    PaymentSummaryComponent,
    PaymentMethodDetailsComponent,
    BookingDetailComponent,
    DialogSeeAllPropertiesComponent,
    IconDropdownComponent,
    BudgetLimitComponent,
    DialogBudgetLimitDetailComponent,
    DialogBudgetLimitMobileComponent,
    DialogShareBudgetComponent,
    DialogShareBudgetDetailComponent,
    DialogRoomNoteComponent,
    DialogRoomNoteDescriptionComponent,
    SafeHTMLPipe,
    SubscriptionComponent,
    DialogInformationCartComponent,
    SplitJoinPipe,
    DialogListComponent,
    FleetCardSelectBoxComponent,
    PaymentMethodComponent,
    PaymentChannelSelectBoxComponent,
    FullyearPipe,
    ActTextAreaComponent,
    DialogCompanyCommunicationTextComponent,
    DialogCompanyCommunicationBannerComponent,
    BannerBillboardComponent,
    DialogBannerOverlayComponent,
    BannerLeaderboardComponent,
    DialogSwitchLangCurrencyComponent,
    DialogChangePasswordComponent,
    DialogPinComponent,
    PinComponent,
    DialogAlertPinComponent,
    VerifyOtpComponent,
    OtpComponent,
    VerifyMethodComponent,
    DialogPhoneComponent,
    DialogMyProfileComponent,
    DialogTaxesFeesComponent,
    DialogUsePromotionCodeComponent
  ],
  entryComponents: [
    DialogAlertComponent,
    DialogComponent,
    ActImageComponent,
    DialogGeneralMessageComponent,
    DialogTermsAndConditionsComponent,
    TermsAndConditionsComponent,
    DialogSuccessComponent,
    DialogErrorComponent,
    DialogConfirmComponent,
    DialogConfirmActionComponent,
    DialogMapComponent,
    DialogCancellationComponent,
    DialogNotifyBudgetComponent,
    DialogMapNearbyComponent,
    DialogMapPoiComponent,
    DialogSpecialDayComponent,
    DialogBookingReportComponent,
    DialogSwitchCompanyComponent,
    DialogTaxAddressComponent,
    DialogBudgetSuggestionComponent,
    DialogCartSummaryComponent,
    DialogMultiPaymentComponent,
    DialogSeeAllPropertiesComponent,
    IconDropdownComponent,
    DialogBudgetLimitDetailComponent,
    DialogBudgetLimitMobileComponent,
    DialogShareBudgetComponent,
    DialogShareBudgetDetailComponent,
    DialogRoomNoteComponent,
    DialogRoomNoteDescriptionComponent,
    DialogInformationCartComponent,
    DialogListComponent,
    FleetCardSelectBoxComponent,
    DialogCompanyCommunicationTextComponent,
    DialogCompanyCommunicationBannerComponent,
    DialogBannerOverlayComponent,
    DialogSwitchLangCurrencyComponent,
    DialogChangePasswordComponent,
    DialogPinComponent,
    DialogAlertPinComponent,
    DialogPhoneComponent,
    DialogMyProfileComponent,
    DialogTaxesFeesComponent,
    DialogUsePromotionCodeComponent,
  ],
  providers: [
    DecimalPipe,
    TitleCasePipe,
    SplitJoinPipe,
    DialogMyProfileForm
  ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/app/components/components.module.ts